import { Link } from "react-router-dom";
import { VelocityCredentialTypes } from "wallet-elementkit/dist/translations";

import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import "../../styles/credentials/credentialsWeb.scss";
import ProfileNoData from "../../components/profile/ProfileNoData/ProfileNoData";
import SingleCategory from "../../components/profile/SingleCategory/SingleCategory";
import { SingleCredential } from "wallet-elementkit/dist/components";

function CredentialsWeb(props) {
	const veloCityTypes = VelocityCredentialTypes;

	const getCertificates = () => {
		return props.certificates.map((certificate) => {
			return {
				...certificate,
				logo: certificate.url,
				title: certificate.name,
				subTitle: certificate.name,
				summaryDetail: certificate.credential_no,
				issuer: {
					logo: certificate.logoLink,
					name: certificate.issuer || "No Issuer",
				},
			};
		});
	};

	const getBadges = () => {
		return props.badges.map((badge) => {
			return {
				...badge,
				logo: badge.badgeUrl,
				title: badge.name,
				subTitle: badge.name,
				summaryDetail: badge.credential_no,
				issuer: {
					logo: badge.logoLink,
					name: badge.issuer || "No Issuer",
				},
			};
		});
	};

	return getCertificates().length > 0 || props.badges.length > 0 ? (
		<div id="profile-credentials-web" className="flex-column ai-fs">
			{getCertificates().length ? (
				<div key={`category-credentials-certificates`}>
					<SingleCategory
						category={"5"}
						title={veloCityTypes[props.activeLanguage.code]["5"]}
						count={props.certificates.length}
						isMobile={false}
						styles={{
							width: "908px",
						}}
						addTranslation={props.addTranslation}
						activeLanguageCode={
							props.activeLanguage && props.activeLanguage.code
								? props.activeLanguage.code
								: "en"
						}
					/>
					<div className="credential-container">
						{getCertificates().map((row, index) => (
							<SingleCredential
								key={`single-credential-${index}`}
								credential={row}
								isSertifierCredential={true}
								actionButtonsOptions={{
									actionButton: {
										customElement: (
											<Link
												to={{
													pathname: props.activeLanguage
														? `/${props.activeLanguage.code}/verify/${row.credential_no}`
														: `/verify/${row.credential_no}`,
												}}
											>
												<BaseButton
													type="secondary"
													size="large"
													loading={false}
													height={40}
													width={240}
												>
													<span>{props.translate("seeDetails")}</span>
												</BaseButton>
											</Link>
										),
									},
								}}
								{...props}
							/>
						))}
					</div>
				</div>
			) : null}
			{getBadges().length ? (
				<div key={`category-credentials-badges`}>
					<SingleCategory
						category={"4"}
						title={veloCityTypes[props.activeLanguage.code]["4"]}
						count={props.badges.length}
						isMobile={false}
						styles={{
							width: "908px",
						}}
						addTranslation={props.addTranslation}
						activeLanguageCode={
							props.activeLanguage && props.activeLanguage.code
								? props.activeLanguage.code
								: "en"
						}
					/>
					<div className="credential-container">
						{getBadges().map((row, index) => (
							<SingleCredential
								key={`single-credential-${index}`}
								credential={row}
								isSertifierCredential={true}
								actionButtonsOptions={{
									actionButton: {
										customElement: (
											<Link
												to={{
													pathname: props.activeLanguage
														? `/${props.activeLanguage.code}/verify/${row.credential_no}`
														: `/verify/${row.credential_no}`,
												}}
											>
												<BaseButton
													type="secondary"
													size="large"
													loading={false}
													height={40}
													width={240}
												>
													<span>{props.translate("seeDetails")}</span>
												</BaseButton>
											</Link>
										),
									},
								}}
								{...props}
							/>
						))}
					</div>
				</div>
			) : null}
		</div>
	) : (
		<ProfileNoData noDataText={props.noDataText} />
	);
}
export default CredentialsWeb;
